"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = exports.ReactQueryDevtools = exports.QueryClientProvider = exports.QueryClient = exports.Hydrate = void 0;
const react_query_1 = require("@tanstack/react-query");
const apiError_1 = __importDefault(require("../utils/gtm/apiError"));
var react_query_2 = require("@tanstack/react-query");
Object.defineProperty(exports, "Hydrate", { enumerable: true, get: function () { return react_query_2.Hydrate; } });
var react_query_3 = require("@tanstack/react-query");
Object.defineProperty(exports, "QueryClient", { enumerable: true, get: function () { return react_query_3.QueryClient; } });
var react_query_4 = require("@tanstack/react-query");
Object.defineProperty(exports, "QueryClientProvider", { enumerable: true, get: function () { return react_query_4.QueryClientProvider; } });
var react_query_devtools_1 = require("@tanstack/react-query-devtools");
Object.defineProperty(exports, "ReactQueryDevtools", { enumerable: true, get: function () { return react_query_devtools_1.ReactQueryDevtools; } });
const useFetch = (options) => {
    const queryRes = (0, react_query_1.useQuery)(options);
    const { isError, error } = queryRes;
    if (isError) {
        const errorData = {
            data: error.response.data,
            status: error.response.status,
        };
        (0, apiError_1.default)(error.response);
        return Object.assign(Object.assign({}, queryRes), { errorData });
    }
    return queryRes;
};
exports.useFetch = useFetch;
